import { ICellRendererParams } from 'ag-grid-community';

import { Status, TextLine } from 'core/elements';
import { ExternalProjectAssociationStatus } from 'projects/enums';
import { Color } from 'theme/enums';
import { IColorMap } from 'theme/types';

import { getAssociationStatusLabelMap } from './utils';

export const associationStatusColorMap: IColorMap = {
  [ExternalProjectAssociationStatus.ACTIVE]: Color.SUCCESS,
  [ExternalProjectAssociationStatus.INACTIVE]: Color.DANGER,
};

export const AssociationStatusCell = ({ value }: ICellRendererParams) => {
  if (!value) {
    return null;
  }

  return (
    <TextLine
      text={
        <Status
          value={value}
          labelMap={getAssociationStatusLabelMap()}
          colorMap={associationStatusColorMap}
        />
      }
      bold
    />
  );
};
